module.exports = __webpack_public_path__ + "assets/img/icon_shares-1.89fba177.svg";